import React, {ReactNode} from "react";
import PageAncestor from "core/common/page/pageAncestor";
import mdEntityService from "core/metamodel/mdEntityService";
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import "invoice/page/invoiceDetail.less";
import {observer} from "mobx-react";
import {ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {loc} from "core/common/config/locales";
import gridService from "core/grid/gridService";
import {MovingBlocks} from "core/grid/gridUtils";
import Grid, {GridLocation} from "core/grid/domain/grid";
import GridComp, {UILOCATION} from "core/grid/component/gridComp";

import 'flag-icon-css/css/flag-icon.css';
import sbToolCriterionService from "../../service/criterionService";
import {Criterion} from "../../domain/criterion/criterionDomain";
import {Tab, Tabs} from "material-ui";
import {tabStyle} from "../../../core/common/config/variables";
import {TabTemplate} from "../../../core/common/config/mui-theme";
import {CRITERION_SCORE_LIST, SUB_CRITERIA_LIST} from "../../gridsContants";
import {CRITERION_ENTITY} from "../../entityConstants";

@observer
export default class CriterionDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Criterion`;
  static icon = 'list';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("SbToolCriterionDetails#fetchData(%O)", query);


    let metadataPromise = mdEntityService.fetchEntityMetadata([CRITERION_ENTITY]);
    let criterionPromise: Promise<Criterion> = sbToolCriterionService.readCriterion(routerParams.id)
    let gridPromise = gridService.fetchGrids(SUB_CRITERIA_LIST, CRITERION_SCORE_LIST);


    return Promise.all([metadataPromise, criterionPromise, gridPromise])
      .then(([entityMap, sbToolCriterionObject, gridLocationMap]: [ObservableMap<MdEntity>, Criterion, ObservableMap<GridLocation>]) => {
        sbToolCriterionService.criterionObject = sbToolCriterionObject;
        sbToolCriterionService.criterionObject.$movingBlocks = new MovingBlocks(SUB_CRITERIA_LIST, true, query.tab,
          new Grid(gridLocationMap.get(SUB_CRITERIA_LIST), sbToolCriterionService.criterionObject.criterionId),
          new Grid(gridLocationMap.get(CRITERION_SCORE_LIST), sbToolCriterionService.criterionObject.criterionId),
        );
        sbToolCriterionService.criterionObject = sbToolCriterionObject.initAfterRead(false);
      })
  }




  componentDidUpdate(prevProps: PageProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      sbToolCriterionService.criterionObject.$movingBlocks.searchExposedGrids(sbToolCriterionService.criterionObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    sbToolCriterionService.criterionObject.$movingBlocks.searchExposedGrids(sbToolCriterionService.criterionObject);
  }

  componentWillUnmount() {
    sbToolCriterionService.criterionObject = null;
  }


  findRootObject() {
    return sbToolCriterionService.criterionObject;
  }


  renderTabs = () : ReactNode => {
    let criterion : Criterion = sbToolCriterionService.criterionObject
    let subCriterionGrid : Grid = criterion.$movingBlocks.getBlock(SUB_CRITERIA_LIST) as Grid;

    let criterionScoreGrid : Grid = criterion.$movingBlocks.getBlock(CRITERION_SCORE_LIST) as Grid;

    const gridCompArray = [
      <GridComp grid={subCriterionGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow key={1}/>,
      <GridComp grid={criterionScoreGrid} uiLocation={UILOCATION.tab} entities={mdEntityService.entityMap} hideGridConfig hideCopyRow key={2}/>
    ];

    const tabArray = gridCompArray.map(gridComp => (
      <Tab label={gridComp.props.grid.label} style={tabStyle} onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.getBlockName()}  value={gridComp.props.grid.getBlockName()}>
        {gridComp}
      </Tab>
    ));


    return (tabArray.length) ? (
      <Tabs value={criterion.$movingBlocks.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} onChange={this.onTabChange} >
        {tabArray}
      </Tabs>
    ) : '';
  }


  render() {
    let criterion : Criterion = sbToolCriterionService.criterionObject

    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column', padding : 20}}>
        <div>
          <h4>{criterion.code + " " + criterion.name}</h4>
          {criterion.description}
        </div>
        <div style={{display: 'flex', flexDirection: 'row'}}>
          {this.renderTabs()}
        </div>

      </main>
    );
  }
}




// WEBPACK FOOTER //
// ./src/sbtool/page/criterion/criterionDetail.tsx